import React from 'react';
import VBControlEnd from './vbControlEnd';
import { CssInput, CssOptionsContainer } from './vbCssComponents';

class VBSearchInput extends React.Component {
    constructor(props){
        super();
        this.state={
            value: props.initial ? props.initial : "",
            showResult: false
        }

        this.controlEnd = React.createRef();
        this.input = React.createRef();
        this.label = React.createRef();
    }

    componentDidMount(){
        this.setState({ labelHeight: this.label.current.clientHeight })

        if(this.props.hasFocus == this.props.id && !this.props.disableAutoFocus) {
            this.input.current.focus()
        }
    }

    setValue(value){
        this.setState({ value: value })
    }

    onChange(e){
        let value = e.target.value
        this.setState({ value: value }, () => {
            if(this.props.onChange){
                this.props.onChange(value);
            }
        });
    }

    onFocus(e){
        // if mobile scroll the input to the top of the page (the timeout is for modern mobile browsers that do auto-aligning)
        if (screen.width <= 768 && !this.props.disableAutoFocus) {
            setTimeout(() => { this.input.current.scrollIntoView({ behavior: 'smooth' }); }, 550);
        }

        this.setState({ showResult: true })

        if(this.props.onFocus){
            this.props.onFocus(e);
        }
    }

    onBlur(e){
        setTimeout(() => {
            this.setState({ showResult: false })
            if(this.props.onBlur){
                this.props.onBlur(e);
            }
        }, 200)
    }

    render() {
        return (
            <div className="w-full">
                <div ref={this.label} onClick={() => {this.input.current.focus()}}>
                    {this.props.label}
                </div>
                <div className="w-full inline-block relative">
                    <CssInput
                        ref={this.input}
                        placeholder={this.props.placeholder}
                        onChange={this.onChange.bind(this)}
                        onFocus={this.onFocus.bind(this)}
                        onBlur={this.onBlur.bind(this)}
                        value={this.state.value}
                        labelHeight={this.state.labelHeight+'px'}
                        className={this.props.inputClass}
                        style={this.props.inputStyle}
                        type="text"
                        disabled={this.props.disabled}
                        required={this.props.required} />

                    {this.props.searchResult && this.state.showResult ? <VBControlEnd ref={this.controlEnd} icon='vb-cross'/> : null}
                    
                    {this.props.searchResult && this.state.showResult ? <CssOptionsContainer className={`absolute overflow-auto ${this.props.optionsContainerClass}`} style={this.props.optionsContainerStyle}>
                        {this.props.searchResult}
                    </CssOptionsContainer> : null}
                </div>
            </div>
        );
    }
}

VBSearchInput.defaultProps = { inputClass: '', inputStyle: null, optionsContainerClass: '', optionsContainerStyle: null, disableAutoFocus: false };

export default VBSearchInput;